import request from './request'

/**
 * 訂單結帳
 * @param {Object} params - 參數
 * @param {string} params.registeredEmail - 使用者電子郵件。
 * @param {string} params.applyDepartment - 申請科系。
 * @param {string} params.entryFormId - 報名表單的ID。
 * @param {Object} data - 要提交的資料
 * @param {string} data.paymentType - 支付方式。
 * @param {string} data.feeItem - 收費項目。
 * @param {string} data.cardNumber - 信用卡號碼。
 * @param {string} data.cardExpiryYear - 信用卡到期年。
 * @param {string} data.cardExpiryMonth - 信用卡到期月。
 * @param {string} data.cardCcv - 信用卡三個數字。
 * @param {string} data.vaccBank - 領款銀行。
 */
function checkoutPayment(params, data) {
  return request({
    url: '/payment/checkoutPayment',
    method: 'post',
    params: params,
    data: data,
  })
}

/**
 * 取得ATM付款資訊
 * @param {Object} params
 * @param {string} params.registeredEmail - 使用者電子郵件
 * @param {string} params.applyDepartment - 申請科系
 * @param {string} params.entryFormId - 報名表單的ID
 * @param {string} params.feeItem - 收費項目
 * @return {Promise}
 */
function getATMToPayPaymentInfo(params) {
  return request({
    url: '/payment/getATMToPayPaymentInfo',
    method: 'get',
    params: params,
  })
}

export default { checkoutPayment, getATMToPayPaymentInfo }
